export const COLOR_ESTADO = {
  EMITIDA: "success",
  ERROR: "error",
  EMITIENDO: "warning",
  PENDIENTE: "default",
  OMITIDA: "default",
};

export const LABEL_ESTADO = {
  EMITIDA: "Emitida",
  ERROR: "Error",
  EMITIENDO: "Emitiendo",
  PENDIENTE: "Pendiente",
  OMITIDA: "Omitida",
};

// Marcas de reconciliacion en las que no hay certeza de que el documento no exista: el item
// queda detenido y el backend rechaza su reintento hasta que una persona lo resuelva.
// Reintentarlo a ciegas puede emitir un segundo documento por la misma operacion. La lista
// es la misma que aplica el servidor para bloquear; si cambia alla, tiene que cambiar aca.
export const RECONCILIACION_SIN_RESOLVER = [
  "PENDIENTE_LOCAL",
  "REVISION_MANUAL",
  "IRRESOLUBLE",
];

export const LABEL_RECONCILIACION = {
  PENDIENTE_LOCAL: "Pendiente de registro local",
  REVISION_MANUAL: "Revisión manual",
  IRRESOLUBLE: "Sin resolución automática",
  RESUELTA: "Resuelta",
};

// Un item ya emitido u omitido no esta detenido: sobre el, la marca es el rastro de algo que
// se resolvio despues. Detiene solo a lo que todavia no termina, que es tambien el criterio
// con el que el backend cuenta los detenidos en los totales.
const ESTADOS_TERMINADOS = ["EMITIDA", "OMITIDA"];

export const estaDetenido = (item) =>
  RECONCILIACION_SIN_RESOLVER.includes(item?.estadoReconciliacion) &&
  !ESTADOS_TERMINADOS.includes(item?.estado);

export const contarDetenidos = (items) =>
  Array.isArray(items) ? items.filter(estaDetenido).length : 0;

// No es un estado del item sino el subconjunto de los errores que quedo detenido: se resuelve
// con estaDetenido, nunca comparando contra item.estado.
export const FILTRO_DETENIDO = "DETENIDO";

export const ESTADOS_FILTRO = [
  { value: "TODOS", label: "Todos" },
  { value: "PENDIENTE", label: "Pendiente" },
  { value: "EMITIENDO", label: "Emitiendo" },
  { value: "EMITIDA", label: "Emitida" },
  { value: "ERROR", label: "Error" },
  { value: FILTRO_DETENIDO, label: "Detenido" },
  { value: "OMITIDA", label: "Omitida" },
];
